export default '2.2.3';



// WEBPACK FOOTER //
// ./src/lib/version.js